import { execute, FilterConditions, INSERT, SELECT, UPDATE } from "@/utils/database_module"
import { BaseCategoryData, Category, SubCategory, SuperCategory } from "@/utils/types"

const super_categories ={
    getAll : async (is_cars : boolean) => {
        const conditions =[{column : "is_deleted" , operator : "=" , value : 0} , {column : "is_cars" , operator : "=" , value : is_cars ? 1 : 0}] as FilterConditions
        const super_categories = await SELECT("super_categories" , { conditions : conditions , order : "display_order ASC"})
        return super_categories
    },

    insert : async (category : BaseCategoryData) => {
        return await INSERT("super_categories" , category)
    },

    update : async (id : number , category : BaseCategoryData) => {
        return await UPDATE("super_categories" , category , [{column : "id" , operator : "=" , value : id}])
     
    },


    delete : async (id : number) => {
        await UPDATE("super_categories" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
        await UPDATE("categories" , { is_deleted : 1 } , [{column : "super_category_id" , operator : "=" , value : id}])
        
        // delete sub categories
        const deletedCategories = await SELECT("categories" , { conditions : [{column : "super_category_id" , operator : "=" , value : id}] , })  as Category[]
        if (deletedCategories.length == 0) return
        const deletedCategoriesIds = deletedCategories.map(c =>c.id ).join(' , ')
        await execute(`UPDATE sub_categories SET is_deleted = 1 WHERE category_id IN ${deletedCategoriesIds}`)

    },

}

const categories ={
    getAll : async () => {
        const conditions =[{column : "is_deleted" , operator : "=" , value : 0}]as FilterConditions
        const categories = await SELECT("categories" , { conditions : conditions , order : "display_order ASC"})
        return categories
    },

    insert : async (category : Omit<Category , "id" | "date" | "modified_date"> ) => {
        return await INSERT("categories" , category)
    },


    update : async (id : number , category : Partial<Category>) => {
        return await UPDATE("categories" , category , [{column : "id" , operator : "=" , value : id}])
    },


    delete : async (id : number) => {
        await UPDATE("categories" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
        await UPDATE("sub_categories" , { is_deleted : 1 } , [{column : "category_id" , operator : "=" , value : id}])
    },

}

const sub_categories ={
    getAll : async () => {
        const conditions =[{column : "is_deleted" , operator : "=" , value : 0}] as FilterConditions
        const sub_categories = await SELECT("sub_categories" , { conditions : conditions , order : "display_order ASC"})
        return sub_categories
    },

    insert : async (category : Omit<SubCategory , "id" | "date" | "modified_date"> ) => {
        return await INSERT("sub_categories" , category)
    },
    update : async (id : number , category : Partial<SubCategory>) => {
        return await UPDATE("sub_categories" , category , [{column : "id" , operator : "=" , value : id}])
     
    },
    delete : async (id : number) => {
        return await UPDATE("sub_categories" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
    },

}



export  {
    super_categories,
    categories,
    sub_categories
}